import { getIsMobileViewport } from "../../../../app/common/util/useIsMobile";

const MOBILE_ACTIONS_WIDTH = 52;
const MOBILE_DEFAULT_COL_WIDTH = 120;

const getViewportWidth = () =>
  typeof window !== "undefined" ? window.innerWidth : 390;

export const getResponsiveColumns = (columns, isMobile) => {
  if (!isMobile) return columns;

  const visibleColumns = columns.filter((col) => !col.mobileHidden);

  return visibleColumns.map((col) => {
    if (col.title === "Actions") {
      return {
        ...col,
        fixed: "right",
        width: MOBILE_ACTIONS_WIDTH,
      };
    }

    return {
      ...col,
      width: col.width || MOBILE_DEFAULT_COL_WIDTH,
    };
  });
};

export const getResponsiveScroll = (columns, isMobile, desktopWidth = 1300) => {
  if (!isMobile) return { x: desktopWidth };

  const visibleColumns = columns.filter((col) => !col.mobileHidden);

  const totalWidth = visibleColumns.reduce((sum, col) => {
    if (col.title === "Actions") {
      return sum + MOBILE_ACTIONS_WIDTH;
    }
    return sum + (col.width || MOBILE_DEFAULT_COL_WIDTH);
  }, 0);

  // scroll.x must exceed viewport or antd squeezes columns instead of scrolling
  return { x: Math.max(totalWidth, getViewportWidth() + 120) };
};

export { getIsMobileViewport };
